import { useCallback, useState } from 'react';
import worksheetService from '../services/worksheetService';

const useWorksheetData = () => {
  const [currentPracticeSheet, setCurrentPracticeSheet] = useState(null);
  const [showPracticeSheetModal, setShowPracticeSheetModal] = useState(false);
  const [showPracticeSheetAnswerKey, setShowPracticeSheetAnswerKey] = useState(false);
  const [isLoadingPracticeSheet, setIsLoadingPracticeSheet] = useState(false);
  const [practiceSheetError, setPracticeSheetError] = useState(null);

  const openPracticeSheet = useCallback(async (taskId) => {
    setIsLoadingPracticeSheet(true);
    setPracticeSheetError(null);
    try {
      const response = await worksheetService.getTaskWorksheet(taskId);
      setCurrentPracticeSheet(response.data);
      setShowPracticeSheetModal(true);
      setShowPracticeSheetAnswerKey(false);
    } catch (error) {
      console.error('Error loading practice sheet:', error);
      setPracticeSheetError(error);
      alert('Error loading practice sheet. Please try again.');
    } finally {
      setIsLoadingPracticeSheet(false);
    }
  }, []);

  const closePracticeSheet = useCallback(() => {
    setShowPracticeSheetModal(false);
    setCurrentPracticeSheet(null);
    setShowPracticeSheetAnswerKey(false);
  }, []);

  const togglePracticeSheetAnswerKey = useCallback(() => {
    setShowPracticeSheetAnswerKey((prev) => !prev);
  }, []);

  const updateCurrentPracticeSheetWorksheet = useCallback((updatedWorksheet) => {
    setCurrentPracticeSheet((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        worksheet: updatedWorksheet
      };
    });
  }, []);

  return {
    currentPracticeSheet,
    showPracticeSheetModal,
    showPracticeSheetAnswerKey,
    isLoadingPracticeSheet,
    practiceSheetError,
    openPracticeSheet,
    closePracticeSheet,
    togglePracticeSheetAnswerKey,
    updateCurrentPracticeSheetWorksheet,
  };
};

export default useWorksheetData;